// extracted by mini-css-extract-plugin
module.exports = {"CheckboxGroupContainer":"CheckboxGroup_CheckboxGroupContainer__1Xs9C"};